import { GENERIC_ERROR_MESSAGE } from '@zr/utilities/constants';
import { apiRequest } from '@zr/utilities/api';

const SKILL_AUTOCOMPLETE_URL = '/skill/autocomplete';

export async function fetchSkillResults(term = '') {
  const uri = SKILL_AUTOCOMPLETE_URL;
  try {
    const response = await apiRequest(uri, {}, term ? `?term=${term}` : '');
    const json = await response.json();

    if (!response.ok) {
      throw json;
    }

    return json.data;
  } catch (error) {
    const { stack } = error;
    const e = error;
    e.message = GENERIC_ERROR_MESSAGE;
    e.stack = stack;
    throw e;
  }
}

export default fetchSkillResults;
